import styles from "./GradientBackdrop.module.scss";

interface GradientBackdropProps {
  className?: string;
  noFooter?: boolean;
}

const GradientBackdrop = ({ className, noFooter }: GradientBackdropProps) => {
  const boundedClass = noFooter ? styles.gradientWrapperBoundedTopOnly : styles.gradientWrapperBounded;
  return <div className={`${styles.gradientWrapper} ${boundedClass} ${className || ""}`}></div>;
};

export default GradientBackdrop;
